import { render, staticRenderFns } from "./OgtVideo.vue?vue&type=template&id=d8a6089c&scoped=true&"
import script from "./OgtVideo.vue?vue&type=script&lang=js&"
export * from "./OgtVideo.vue?vue&type=script&lang=js&"
import style0 from "./OgtVideo.vue?vue&type=style&index=0&id=d8a6089c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a6089c",
  null
  
)

export default component.exports